export enum VOICE_APIS {
  TTS1 = "elevenlabs",
  TTS2 = "ai4bharat",
  TTS3 = "xtts",
}

export const AVATAR_POSITION = {
  CENTER: [0, -4.8, 6.5],
  RIGHT: [2, -4.8, 6.5],
  LEFT: [-2, -4.8, 6.5],
};

export enum CALL_TYPE {
  VIDEO = "video",
  AUDIO = "audio",
  CHAT = "chat",
  USER_CHOICE = "userChoice",
}

export enum NOTIFICATION_TYPE {
  ROLEPLAY_ASSIGNED = "roleplay_assigned",
  ROLEPLAY_RESULT = "roleplay_result",
  FEED_CREATED = "feed_created",
  SURVEY_ASSIGNED = "survey_assigned",
  COACH_RESULT = "coach_result",
  TRAINING = "training",
  TRAINING_ASSIGNED = "training_assigned",
  TRAINING_PUBLISHED = "training_published",
  EVALUATION_ASSIGNED = "evaluation_assigned",
  EVALUATION_EXPIRY_REMINDER = "evaluation_expiry_reminder",
  ASSESSMENT_ASSIGNED = "assessment_assigned",
  ASSESSMENT_EXPIRY_REMINDER = "assessment_expiry_reminder",
  EVALUATION_RESULT = "evaluation_result",
  LOGIN_DETECTED = "login_detected",
  ISSUE = "issue",
  MODULE_PUBLISHED = "module_published",
  ON_BOARDING_TRAINING_ASSIGNED = "on_boarding_training_assigned",
  ON_BOARDING_TRAINING_EXPIRED = "on_boarding_training_expired",
}
